import React from 'react';
import { selectedStateOptions } from './AddressFieldsHelpers';
import { SelectField } from './select-field';

const ProvinceSelectField = React.forwardRef(
  (
    { before, afterField, after, wrapperElement, id, label, name, text, help, options: _options, country }: any,
    ref
  ) => {
    return (
      <SelectField
        ref={ref}
        //@ts-ignore
        id={id}
        //@ts-ignore
        name={name}
        //@ts-ignore
        required
        options={selectedStateOptions(country.toLowerCase())}
        {...{ before, afterField, after, id, label, name, text, help, wrapperElement }}
      />
    );
  }
);

export default ProvinceSelectField;
